import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { environment } from 'src/environments/environment';
import { MeasureManagementService } from '../../measure-management/measure-management.service';
import { ResearchManagementService } from '../research-management.service';

@Component({
  selector: 'app-manage-research',
  templateUrl: './manage-research.component.html',
  styleUrls: ['./manage-research.component.scss']
})
export class ManageResearchComponent implements OnInit {
  isLoading: boolean;
  isEdit: boolean;
  isViewOnly: boolean = true;
  researchForm: FormGroup;
  allActiveMeasure;
  researchImg: string;
  researchImgFile: File;
  researchId: string;

  researchDocument: string;
  researchDocumentFile: File;
  imgEdit: boolean = false;
  docEdit: boolean = false;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '400px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '100%',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentNews',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  };

  editorConfigConsent: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '300px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '100%',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentNews',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  };

  editorConfigDisable: AngularEditorConfig = {
    editable: false,
    spellcheck: true,
    height: 'auto',
    minHeight: '400px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '100%',
    translate: 'yes',
    enableToolbar: false,
    showToolbar: false,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentNews',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  };

  editorConfigConsentDisable: AngularEditorConfig = {
    editable: false,
    spellcheck: true,
    height: 'auto',
    minHeight: '300px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '100%',
    translate: 'yes',
    enableToolbar: false,
    showToolbar: false,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentNews',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  };

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private gobalFunctionService: GobalFunctionService,
    private measureManagementService: MeasureManagementService,
    private researchManagementService: ResearchManagementService,
  ) { }

  ngOnInit(): void {
    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));

    this.researchForm = this.fb.group({
      name: ['', Validators.required],
      consent: ['', Validators.required],
      detail: ['', Validators.required],
      researchImg: [''],
      date: ['', Validators.required],
      alwaysOpen: [false],
      researchDocument: [''],
      coin: ['', Validators.required],
      coinShare: ['', Validators.required],
      target: this.fb.array([]),
      measures: this.fb.array([])
    })

    this.measureManagementService.getActiveMeasure().pipe(
      map(res => {
        // // console.log(res);
        this.allActiveMeasure = res.result;
      })
    ).subscribe();

    if (this.isEdit) {
      this.researchId = new URL(location.href).searchParams.get('research_id');
      this.gobalFunctionService.setTitle('แก้ไขวิจัย');

      this.researchManagementService.getDetailResearchById(this.researchId).pipe(
        map(res => {
          // // console.log(JSON.parse(res.result[0].VALUE).measureOfresearch);
          // // console.log(JSON.parse(res.result[0].VALUE).measureOftraget);
          // console.log(res.result[0]);

          this.researchForm = this.fb.group({
            name: [res.result[0].RESEARCH_NAME, Validators.required],
            consent: [res.result[0].CONSENT, Validators.required],
            detail: [res.result[0].RESEARCH_DETAIL, Validators.required],
            researchImg: [''],
            date: [res.result[0].ALWAYS_OPEN == 'true' ? [null] : [new Date(res.result[0].RESEARCH_START), new Date(res.result[0].RESEARCH_END)], Validators.required],
            alwaysOpen: [res.result[0].ALWAYS_OPEN == 'true' ? true : false],
            researchDocument: [''],
            coin: [res.result[0].COIN, Validators.required],
            coinShare: [res.result[0].COIN_SHARE, Validators.required],
            target: this.fb.array([]),
            measures: this.fb.array([])
          })
          this.researchImg = res.result[0].IMAGE_ORIGANAL;
          this.researchDocument = res.result[0].DOC_ORIGINAL;
          this.setTarget(JSON.parse(res.result[0].VALUE).measureOftraget);
          this.setResearch(JSON.parse(res.result[0].VALUE).measureOfresearch);
          // console.log(this.researchForm);
          // console.log(this.measureArray);

        })
      ).subscribe();
    } else {
      this.gobalFunctionService.setTitle('สร้างวิจัย');
    }
  }

  createResearch(form) {
    // console.log(form);
    this.isLoading = true;
    let problem = {
      isWrong: false,
      msg: ''
    }
    // // console.log(form.measures);
    form.measures.map((m, i) => {
      // console.log(m);
      if (m.type === 'age' && (m.from_age >= m.to_age)) {
        problem.isWrong = true;
        problem.msg = 'ช่วงอายุไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง';
      }
    })

    if (problem.isWrong) {
      alert(problem.msg);
      this.isLoading = false;
    } else {
      this.researchManagementService.createResearch(form).pipe(
        switchMap(res => {
          // console.log(res);
          this.isLoading = false;
          if (res.success) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.id = 'modalConfirm';
            dialogConfig.width = '400px';
            dialogConfig.data = {
              title: 'สำเร็จแล้ว',
              description: `<img src="../../../assets/check.png" width="100px;" class="img-center">สร้างวิจัย "${form.name}" สำเร็จแล้ว`,
              cancleBtnText: 'ยืนยัน',
              customStyle: 'background-color: #58595B;'
            }

            const modal = this.matDialog.open(ModalComponent, dialogConfig);
            return modal.afterClosed().pipe(
              map(res2 => {
                if (!res2) {
                  window.opener.location.reload();
                  setTimeout(() => {
                    window.close()
                  }, 100);
                }
              })
            )
          } else {
            this.isLoading = false;
            alert(res.message);
            return of(null);
          }
        }),
        catchError(err => {
          this.isLoading = false;
          alert(err.error.message)
          return of(null);
        })
      ).subscribe();
    }
  }

  editResearch(form) {
    // console.log(form);
    this.isLoading = true;
    const editDetail = {
      id: this.researchId,
      imgEdit: this.imgEdit,
      docEdit: this.docEdit
    }
    let problem = {
      isWrong: false,
      msg: ''
    }

    form.measures.map((m, i) => {
      // console.log(m);
      if (m.type === 'age' && (m.from_age >= m.to_age)) {
        problem.isWrong = true;
        problem.msg = 'ช่วงอายุไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง';
      }
    })

    if (problem.isWrong) {
      alert(problem.msg);
      this.isLoading = false;
    } else {
      this.researchManagementService.editResearchById(form, editDetail).pipe(
        switchMap(res => {
          // console.log(res);
          this.isLoading = false;
          if (res.success) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.id = 'modalConfirm';
            dialogConfig.width = '400px';
            dialogConfig.data = {
              title: 'สำเร็จแล้ว',
              description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกวิจัย "${form.name}" สำเร็จแล้ว`,
              cancleBtnText: 'ยืนยัน',
              customStyle: 'background-color: #58595B;'
            }

            const modal = this.matDialog.open(ModalComponent, dialogConfig);
            return modal.afterClosed().pipe(
              map(res2 => {
                // console.log(res2);
                if (!res2) {
                  window.opener.location.reload();
                  setTimeout(() => {
                    window.close()
                  }, 100);
                }
              })
            )
          } else {
            this.isLoading = false;
            alert(res.message);
            return of(null);
          }
        }),
        catchError(err => {
          this.isLoading = false;
          alert(err.error.message)
          return of(null);
        })
      ).subscribe();
    }
  }

  setDate(e, form) {
    form.patchValue({
      start: e.value[0],
      end: e.value[1]
    })
    form.updateValueAndValidity();
  }

  setMeasure(form, index, m) {
    let selectedMeasure = this.allActiveMeasure.filter(am => am.MEASURE_ID === m.value.measure_id);

    form.controls[index].patchValue({
      measure_id: selectedMeasure[0].MEASURE_ID,
      measure_name: selectedMeasure[0].MEASURE_NAME
    })
    form.updateValueAndValidity();
  }

  setAge(form) {
    form.patchValue({
      from_age: form.value.start_year * 12 + form.value.start_month,
      to_age: form.value.end_year * 12 + form.value.end_month
    })
    form.updateValueAndValidity();
  }

  setTarget(data) {
    // console.log(data);

    for (let i = 0; i < data.length; i++) {
      this.targetArray.push(
        this.fb.group({
          type: [data[i].type, Validators.required],
          question: [data[i].question, Validators.required],
          choices: this.fb.array([])
        })
      );
      for (let j = 0; j < data[i].choices.length; j++) {
        this.targetArray.at(i).get('choices')['controls'].push(
          this.fb.group({
            choices_id: j + 1,
            choices_detail: [data[i].choices[j].choices_detail, Validators.required]
          })
        )
      }
    }
  }

  setResearch(data) {
    // console.log(data);
    for (let i = 0; i < data.length; i++) {
      if (data[i].type === 'time') {
        this.measureArray.push(
          this.fb.group({
            wave_id: data[i].wave_id,
            type: [data[i].type, Validators.required],
            moment: [data[i].moment],
            start: data[i].start,
            end: data[i].end,
            start_year: '',
            start_month: '',
            end_year: '',
            end_month: '',
            from_age: '',
            to_age: '',
            measures: this.fb.array([])
          })
        );
      } else if (data[i].type === 'age') {
        this.measureArray.push(
          this.fb.group({
            wave_id: data[i].wave_id,
            type: [data[i].type, Validators.required],
            moment: '',
            start: '',
            end: '',
            start_year: data[i].start_year,
            start_month: data[i].start_month,
            end_year: data[i].end_year,
            end_month: data[i].end_month,
            from_age: data[i].from_age,
            to_age: data[i].to_age,
            measures: this.fb.array([])
          })
        );
      }
      for (let j = 0; j < data[i].measures.length; j++) {
        this.measureArray.at(i).get('measures')['controls'].push(
          this.fb.group({
            measure_id: [data[i].measures[j].measure_id, Validators.required],
            measure_name: [data[i].measures[j].measure_name, Validators.required]
          })
        )
      }
    }
  }

  checkYear(e, form, key) {
    if (e.target.valueAsNumber > 100) {
      e.target.valueAsNumber = 100;
      form.controls[key].setValue(100);
    } else if (e.target.valueAsNumber < 1) {
      e.target.valueAsNumber = 1;
      form.controls[key].setValue(1);
    }
  }

  checkMonth(e, form, key) {
    if (e.target.valueAsNumber > 11) {
      e.target.valueAsNumber = 11;
      form.controls[key].setValue(11);
    } else if (e.target.valueAsNumber <= 0) {
      e.target.valueAsNumber = 0;
      form.controls[key].setValue(0);
    }
  }

  onCoverSelected(e, form) {
    const fileType = this.gobalFunctionService.getTypeFile(e.target.files[0]);

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {
        this.researchImg = e.target.files[0].name;
        this.imgEdit = true;
        const file = (e.target as HTMLInputElement).files[0];
        this.researchImgFile = file;

        form.patchValue({
          researchImg: file
        });
        form.get('researchImg').updateValueAndValidity();
      }
    } else {
      alert('การอัปโหลดรูปภาพรองรับไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  onDocumentSelected(e, form) {
    const fileType = this.gobalFunctionService.getTypeFile(e.target.files[0]);

    if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx' || fileType === 'xlsx' || fileType === 'csv') {
      if (e.target.files && e.target.files[0]) {
        this.researchDocument = e.target.files[0].name;
        this.docEdit = true;
        const file = (e.target as HTMLInputElement).files[0];
        this.researchDocumentFile = file;

        form.patchValue({
          researchDocument: file
        });
        form.get('researchDocument').updateValueAndValidity();
      }
    } else {
      alert('การอัปโหลดรองรับไฟล์ CSV, XLSX, PDF เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  deleteResearchImg(form) {
    this.researchImg = '';
    this.imgEdit = true;
    form.patchValue({
      researchImg: ''
    });
    form.get('researchImg').updateValueAndValidity()
  }

  deleteResearchDocument(form) {
    this.researchDocument = '';
    this.docEdit = true;
    form.patchValue({
      researchDocument: ''
    });
    form.get('researchDocument').updateValueAndValidity()
  }

  addMeasures() {
    // console.log(this.measureArray.length);

    if (this.measureArray.length > 0) {
      if (this.measureArray.value[0].type === 'time') {
        this.measureArray.push(
          this.fb.group({
            wave_id: [`WV${new Date().getTime()}`, Validators.required],
            type: [this.measureArray.value[0].type, Validators.required],
            moment: ['', Validators.required],
            start: ['', Validators.required],
            end: ['', Validators.required],
            start_year: '',
            start_month: '',
            end_year: '',
            end_month: '',
            from_age: '',
            to_age: '',
            measures: this.fb.array([])
          })
        );
      } else {
        this.measureArray.push(
          this.fb.group({
            wave_id: [`WV${new Date().getTime()}`, Validators.required],
            type: [this.measureArray.value[0].type, Validators.required],
            moment: '',
            start: '',
            end: '',
            start_year: ['', Validators.required],
            start_month: ['', Validators.required],
            end_year: ['', Validators.required],
            end_month: ['', Validators.required],
            from_age: ['', Validators.required],
            to_age: ['', Validators.required],
            measures: this.fb.array([])
          })
        );
      }
      this.addSubMeasure(this.measureArray.at(this.measureArray.length - 1).get('measures'));
    } else {
      this.measureArray.push(
        this.fb.group({
          wave_id: [`WV${new Date().getTime()}`, Validators.required],
          type: ['', Validators.required],
          moment: '',
          start: '',
          end: '',
          start_year: '',
          start_month: '',
          end_year: '',
          end_month: '',
          from_age: '',
          to_age: '',
          measures: this.fb.array([])
        })
      );
    }
  }

  addTarget() {
    this.targetArray.push(
      this.fb.group({
        type: ['', Validators.required],
        question: ['', Validators.required],
        choices: this.fb.array([])
      })
    );
  }

  addChoice(form) {
    form.push(
      this.fb.group({
        choices_id: form.length + 1,
        choices_detail: ['', Validators.required]
      })
    )
  }

  addSubMeasure(form) {
    form.push(
      this.fb.group({
        measure_id: ['', Validators.required],
        measure_name: ['', Validators.required]
      })
    )
  }

  clearForm(form, type) {
    // console.log(form);

    if (type === 'target') {
      while (form.get('choices').length !== 0) {
        form.get('choices').removeAt(0);
      }
      form.patchValue({
        choices: [],
        question: ''
      })

      if (form.value.type === 'choices' || form.value.type === 'checkbox') {
        this.addChoice(form.get('choices'));
      }

      form.controls['type'].setValidators([Validators.required]);
      form.controls['question'].setValidators([Validators.required]);

      form.controls['type'].updateValueAndValidity();
      form.controls['question'].updateValueAndValidity();
    } else {
      while (this.measureArray.length != 1) {
        this.measureArray.removeAt(this.measureArray.length - 1)
        // console.log(this.measureArray.length);
      }

      form.patchValue({
        moment: '',
        start: '',
        end: '',
        start_year: '',
        start_month: '',
        end_year: '',
        end_month: '',
        from_age: '',
        to_age: ''
      });

      if (form.get('measures').length === 0) {
        this.addSubMeasure(form.get('measures'));
      }

      if (form.value.type === 'time') {
        form.controls['wave_id'].setValidators([Validators.required]);
        form.controls['type'].setValidators([Validators.required]);
        form.controls['moment'].setValidators([Validators.required]);
        form.controls['start'].setValidators([Validators.required]);
        form.controls['end'].setValidators([Validators.required]);
        form.controls['start_year'].clearValidators();
        form.controls['start_month'].clearValidators();
        form.controls['end_year'].clearValidators();
        form.controls['end_month'].clearValidators();
        form.controls['from_age'].clearValidators();
        form.controls['to_age'].clearValidators();
      } else if (form.value.type === 'age') {
        form.controls['wave_id'].setValidators([Validators.required]);
        form.controls['type'].setValidators([Validators.required]);
        form.controls['moment'].clearValidators();
        form.controls['start'].clearValidators();
        form.controls['end'].clearValidators();
        form.controls['start_year'].setValidators([Validators.required]);
        form.controls['start_month'].setValidators([Validators.required]);
        form.controls['end_year'].setValidators([Validators.required]);
        form.controls['end_month'].setValidators([Validators.required]);
        form.controls['from_age'].setValidators([Validators.required]);
        form.controls['to_age'].setValidators([Validators.required]);
      }
      form.controls['wave_id'].updateValueAndValidity();
      form.controls['type'].updateValueAndValidity();
      form.controls['moment'].updateValueAndValidity();
      form.controls['start'].updateValueAndValidity();
      form.controls['end'].updateValueAndValidity();
      form.controls['start_year'].updateValueAndValidity();
      form.controls['start_month'].updateValueAndValidity();
      form.controls['end_year'].updateValueAndValidity();
      form.controls['end_month'].updateValueAndValidity();
      form.controls['from_age'].updateValueAndValidity();
      form.controls['to_age'].updateValueAndValidity();
    }
  }

  clearValueResearchDate(form) {
    form.value.alwaysOpen = !form.value.alwaysOpen;
    // console.log(form.value.alwaysOpen);
    if (form.value.alwaysOpen) {
      form.controls['date'].setValue(null);
      form.controls['date'].clearValidators();
    } else {
      form.controls['date'].setValidators([Validators.required]);
    }
    form.controls['date'].updateValueAndValidity();
    // console.log(form);
  }

  edit() {
    this.isViewOnly = !this.isViewOnly;

    if (this.isViewOnly) {
      this.gobalFunctionService.setTitle('รายละเอียดวิจัย');
      this.researchImg = null;
      this.researchImgFile = null;
      this.researchDocument = null;
      this.researchDocumentFile = null;
      this.imgEdit = false;
      this.docEdit = false;

      this.researchManagementService.getDetailResearchById(this.researchId).pipe(
        map(res => {
          this.researchForm = this.fb.group({
            name: [res.result[0].RESEARCH_NAME, Validators.required],
            consent: [res.result[0].CONSENT, Validators.required],
            detail: [res.result[0].RESEARCH_DETAIL, Validators.required],
            researchImg: [''],
            date: [res.result[0].ALWAYS_OPEN == 'true' ? [null] : [new Date(res.result[0].RESEARCH_START), new Date(res.result[0].RESEARCH_END)], Validators.required],
            alwaysOpen: [res.result[0].ALWAYS_OPEN == 'true' ? true : false],
            researchDocument: [''],
            coin: [res.result[0].COIN, Validators.required],
            coinShare: [res.result[0].COIN_SHARE, Validators.required],
            target: this.fb.array([]),
            measures: this.fb.array([])
          })
          this.setTarget(JSON.parse(res.result[0].VALUE).measureOftraget);
          this.setResearch(JSON.parse(res.result[0].VALUE).measureOfresearch);
        })
      ).subscribe();
    } else {
      this.gobalFunctionService.setTitle('แก้ไขวิจัย');
    }
  }

  deleteResearch() {
    const body = {
      RESEARCH_ID: this.researchId
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '500px';
    dialogConfig.data = {
      title: 'ลบแบบวิจัย',
      description: `<h5>ต้องการลบแบบวิจัย <span class="text-primary">"${this.researchForm.value.name}"</span> ใช่หรือไม่</h5>`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
      customStyle: 'background-color: #58595B;'
    }

    const modalDelete = this.matDialog.open(ModalComponent, dialogConfig);
    modalDelete.afterClosed().pipe(
      switchMap(isDelete => {
        this.isLoading = true;
        if (isDelete) {
          return this.researchManagementService.delResearchById(body).pipe(
            switchMap(res => {
              if (res.success) {
                this.isLoading = false;
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.id = 'modalConfirm';
                dialogConfig.width = '500px';
                dialogConfig.data = {
                  title: 'ลบวิจัยสำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                  <h5>ลบวิจัย <span class="text-primary">"${this.researchForm.value.name}"</span> สำเร็จแล้ว</h5>`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig);
                return modal.afterClosed().pipe(
                  map(res => {
                    if (!res) {
                      window.opener.location.reload();
                      setTimeout(() => {
                        window.close()
                      }, 10);
                    }
                  })
                )
              } else {
                alert(res.message);
                return of(null);
              }
            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err.error.message)
        this.isLoading = false;
        return of(null);
      }),
    ).subscribe()
  }

  deleteQuestion(i) {
    this.targetArray.removeAt(i);
  }

  deleteChoice(form, index) {
    // // console.log(form);
    form.removeAt(index)
    form.controls.map((res, i) => {
      res.patchValue({
        choices_detail: res.value.choices_detail,
        choices_id: i + 1
      })
    })
  }

  deleteMeasure(i) {
    this.measureArray.removeAt(i);
  }

  deleteSubMeasure(form, index) {
    form.removeAt(index)
  }

  get targetArray(): FormArray {
    return this.researchForm.get('target') as FormArray;
  }

  get measureArray(): FormArray {
    return this.researchForm.get('measures') as FormArray;
  }

  isHaveMeasureType(): boolean {
    return this.measureArray.value[0].type ? true : false;
  }

  checkMoreThanZero(e) {
    if (e.target.value < 0) {
      e.target.value = 0;
    }
  }
}
